import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { AddressData } from './address.api'
import { ItemData } from './item.api'
import { SiteData } from './site.api'

export interface SubscriberData {
  id: number
  addressId: number
  name: string
  logo?: string
  blockedAt?: string
  createdAt: string
  updatedAt: string
  sitesCount: number
  usersCount: number
  isBlocked: boolean
  address?: AddressData
}

export interface SubscriberCreateRequest {
  name?: string
  logo?: File | null
  address?: string
  city?: string
  state?: string
  zip?: string
}

export interface SubscriberSearchItemByCodeRequest {
  id?: number
  code?: string
}

export type SubscriberUpdateRequest = SubscriberCreateRequest

const routes = {
  list: '/subscribers',
  listSites: '/subscribers/{id}/sites',
  searchItemByCode: '/subscribers/{id}/items/search/code/{code}',
  block: '/subscribers/{id}/block',
  unblock: '/subscribers/{id}/unblock',
  create: '/subscribers',
  read: '/subscribers/{id}',
  update: '/subscribers/{id}'
}

export default {
  list (callback: ResponseCallback<SubscriberData[]>) {
    api.get(routes.list, {}, callback)
  },

  listSites (id: number, callback: ResponseCallback<SiteData[]>) {
    const url = routeUtil.replaceParams(routes.listSites, { id })
    api.get(url, {}, callback)
  },

  searchItemByCode (
    params: SubscriberSearchItemByCodeRequest,
    callback: ResponseCallback<ItemData[]>
  ) {
    const url = routeUtil.replaceParams(routes.searchItemByCode, params)
    api.get(url, {}, callback)
  },

  block (id: number, callback: ResponseCallback<SubscriberData>) {
    const url = routeUtil.replaceParams(routes.block, { id })
    api.patch(url, {}, callback)
  },

  unblock (id: number, callback: ResponseCallback<SubscriberData>) {
    const url = routeUtil.replaceParams(routes.unblock, { id })
    api.patch(url, {}, callback)
  },

  create (
    payload: SubscriberCreateRequest,
    callback: ResponseCallback<SubscriberData>
  ) {
    api.postForm(routes.create, payload, callback)
  },

  read (id: number, callback: ResponseCallback<SubscriberData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: SubscriberUpdateRequest,
    callback: ResponseCallback<SubscriberData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.postForm(url, payload, callback)
  }
}
